<template>
  <a-modal v-model="visible" :title="$t('选择字段')" width="80%" @ok="handleComplete">
    <a-select v-if="tables && tables.length > 1" style="width: 300px;" :placeholder="$t('请选择数据表')" v-model="selectedTableName" :options="tables" @change="handleTableNameChange" />
    <a-table rowKey="columnName" :pagination="false" :columns="columns" :dataSource="dataSource" :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: handleTableSelectionChange, type: selectType }" @change="handleTableChange"></a-table>
  </a-modal>
</template>
<script>
import { getDbTableColumns } from '@/api/app/db'

export default {
  props: {
    selectType: {
      type: String,
      default: 'checkbox'
    }
  },
  data() {
    return {
      queryParams: {},
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
      appId: null,
      db: null,
      tables: [],
      selectedTableName: null,
      tableColumnsCache: {},
      userData: null
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('数据库'),
          dataIndex: 'db'
        },
        {
          title: this.$t('表名'),
          dataIndex: 'tableName'
        },
        {
          title: this.$t('字段名'),
          dataIndex: 'columnName'
        },
        { 
          title: this.$t('字段类型'), 
          dataIndex: 'dataType'
        },
        { 
          title: this.$t('可否为空'), 
          dataIndex: 'nullable',
          customRender: (text, record) => {
            return record.nullable ? this.$t('可空') : this.$t('非空')
          }
        },
        {
          title: this.$t('默认值'),
          dataIndex: 'dataDefault'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'comments'
        },
      ]
    },
  },
  methods: {
    show(appId, db, tables, userData) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.appId = appId
      this.db = db
      this.pagination.total = 0
      this.pagination.current = 1
      this.tables = tables
      this.userData = userData
      this.selectedTableName = null
      this.dataSource = []
      this.queryParams = []
      if (this.tables && this.tables.length > 0) {
        this.selectedTableName = this.tables[0].value
      }
      this.refresh()
      this.visible = true
    },
    handleComplete() {
      if (this.selectedRows.length == 0) {
        return
      }
      const alias = this.tables.find(e => e.value === this.selectedTableName)?.alias ?? null
      this.selectedRows.forEach(r => {
        r.tableAlias = alias
      })
      this.$emit('ok', this.selectedRows, this.userData)
      this.visible = false
    },
    handleTableSelectionChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    handleTableNameChange(v) {
      this.selectedTableName = v
      this.refresh()
    },
    refresh() {
        // this.loadTableData({ pageNum: this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
        this.loadTableData(this.queryParams)
    },
    loadTableData(params) {
      if (!this.appId || !this.db || !this.selectedTableName) {
        return
      }
      const tableName = this.tables.find(e => e.value === this.selectedTableName)?.tableName
      const key = `${this.appId}-${this.db}-${tableName}`
      const cacheData = this.tableColumnsCache[key]
      if (cacheData?.length) {
        this.dataSource = cacheData
        return
      }
      getDbTableColumns({ ...params, appId: this.appId, db: this.db, tableName }).then(res => {
        if (res.code === 0) {
          this.dataSource = res.data
          this.tableColumnsCache[key] = res.data
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      // this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
      this.loadTableData(this.queryParams)
    }
  }
}
</script>